export const ARRIVED = 'ARRIVED'
export const ENTERED = 'ENTERED'
export const STOCKPARTRECEIVED = 'STOCK PART RECEIVED'
export const STOCKRECEIVED = 'STOCK RECEIVED'
